import { Component, OnInit, Input } from '@angular/core';
import { FormElementSocialMedia } from '../shared/model/social-media/form-element-social-media.model';
import { FormFields } from '../shared/service/form-fields.service';
import { FormElementMembershipLevelType } from '../shared/model/membership-level/form-element-membership-level-type.model';
import { BenefitService } from '../../benefits/shared/benefit.service';
import { FormElementMembershipLevel } from '../shared/model/membership-level/form-element-membership-level.model';
import { moveItemInArray } from '@angular/cdk/drag-drop';

@Component({
  selector: 'wl-form-builder-membership-level-edit-element',
  providers: [BenefitService],
  templateUrl: 'form-builder-membership-level-edit-element.component.html',
  styleUrls: ['./form-builder-membership-level-edit-element.component.less'],
    standalone: false
})
export class FormBuilderMembershipLevelEditElementComponent {
  public membershipLevelSettings: FormElementMembershipLevel;
  public selectedMemberShipLevel: FormElementMembershipLevelType;
  public _allFields: Array<FormElementMembershipLevelType>;

  public constructor(private _benefitService: BenefitService) {
    this.membershipLevelSettings = new FormElementMembershipLevel();
    this._allFields = [];
  }

  ngOnInit(): void {}

  membershipLevelSelected() {
    let duplicateSelected =
      this.membershipLevelSettings.MembershipLevelOptions.findIndex(
        (x) => x.MembershipLevelId == this.selectedMemberShipLevel.MembershipLevelId
      ) > -1;

    if (!duplicateSelected) {
      this.membershipLevelSettings.MembershipLevelOptions.push(this.selectedMemberShipLevel);
    }
  }

  removeMembershipLevel(index: number) {
    this.membershipLevelSettings.MembershipLevelOptions.splice(index, 1);
  }

  sortMembershipLevel(event) {
    moveItemInArray(this.membershipLevelSettings.MembershipLevelOptions, event.previousIndex, event.currentIndex);
  }

  // get any fields that might not already be in the array
  refetchMembershipLevels(): void {
    if (this._allFields.length) return;
    this._benefitService.getMembershipLevels().then((data: any) => {
      this._allFields = data.Result.map((x: any) => {
        let field = new FormElementMembershipLevelType();
        field.MembershipLevelId = x.MembershipLevelId;
        field.Name = x.Name;
        return field;
      });
    });
  }
}
